import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "twitter",
  "use": "twitter-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"twitter\"><path d=\"M512 96c-19 10-38 13-61 16 23-13 39-32 45-58-19 13-42 20-67 26-19-19-48-32-77-32-54 0-102 48-102 106 0 9 0 16 3 22-87-3-167-45-218-109-9 16-13 32-13 55 0 35 20 67 48 86-16 0-32-6-48-13 0 51 36 93 84 103-10 3-20 3-29 3-7 0-13 0-19-3 12 41 51 73 99 73-35 29-80 45-131 45H0c48 29 102 48 160 48 192 0 298-160 298-298v-12c22-16 41-36 54-58z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/twitter.svg
// module id = 202
// module chunks = 0